module.exports = __webpack_public_path__ + "media/images/area/icon_weather_23-f9d6889b77ec42e5910400ce8f4fcb5e.png";